import { versionUtils } from '@src/shared/lib';
import { useQuery } from '@tanstack/react-query';

// How often a long-lived tab re-checks the deployed version.
const POLL_INTERVAL_MS = 5 * 60 * 1000;

/**
 * Polls the server-published deploy version (also refetching when the tab
 * regains focus) and reports whether it differs from the version baked into the
 * currently running bundle. Disabled in dev, where no version.json is served.
 */
export function useVersionCheck() {
  const runningVersion = versionUtils.getBuildVersion();

  const { data: deployedVersion } = useQuery({
    queryKey: ['root', 'app-version'],
    queryFn: versionUtils.fetchDeployedVersion,
    enabled: import.meta.env.PROD,
    refetchInterval: POLL_INTERVAL_MS,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    staleTime: 0,
    gcTime: 0,
    retry: false,
  });

  const isOutdated = Boolean(deployedVersion) && deployedVersion !== runningVersion;

  return { runningVersion, deployedVersion, isOutdated };
}
